import React, { FunctionComponent, useEffect, useState } from "react"
import ReactPlayer from "react-player"
import { iFile } from "../../definitions/File"
import { eVideoVersions } from "../../definitions/Video"
import { useVideoUrl } from "../../hooks/useVideoUrl"
import { get } from "../../store/data/actions"

interface iProps {
  url: string
  muted?: boolean
  autoplay?: boolean
  controls?: boolean
  loop?: boolean
}

const Video: FunctionComponent<iProps> = ({
  url,
  muted = true,
  autoplay = true,
  controls = true,
  loop = true,
}) => {
  return (
    <ReactPlayer
      url={url}
      muted={muted}
      playing={autoplay}
      controls={controls}
      loop={loop}
    />
  )
}

interface iWrapProps {
  file: string
  fileCollection: string
}

export const VideoWrap: FunctionComponent<Partial<iProps> & iWrapProps> = ({
  file,
  fileCollection,
  ...rest
}) => {
  const [url, setUrl] = useState("")
  useEffect(() => {
    if (file && fileCollection) {
      get<iFile>({
        link: "/v1/file",
        query: { _id: file, collection: fileCollection },
      })
        .then((res) => {
          setUrl(useVideoUrl(eVideoVersions.original, res.versions))
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [file, fileCollection])

  if (url) {
    return <Video {...rest} url={url} />
  }
  return null
}

export default Video
